import { useFormik } from "formik";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";
import React from "react";
import * as Yup from "yup";
import { invalidEmailText, reqText } from "../../../utils/commonText";
import { Props } from "./AdminLoginForm.config";

const AdminLoginForm: React.FC<Props> = ({
  setFormData,
  submitHandler,
  setFormType,
}) => {
  const loginSchema = Yup.object().shape({
    email: Yup.string().email(invalidEmailText()).required(reqText()),
    password: Yup.string()
      .required(reqText())
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*._-])(?=.{8,})/,
        "Şifre en az 8 karakter olmalı. En az bir büyük harf, bir küçük harf, bir rakam ve bir özel karakter içermelidir."
      ),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (data) => {
      setFormData(data);
      submitHandler(data);
      setFormType("admin");
      formik.resetForm();
    },
  });

  const isFormFieldValid = (name: keyof typeof formik.values) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name: keyof typeof formik.values) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">
          {typeof formik.errors[name] === "string" ? formik.errors[name] : ""}
        </small>
      )
    );
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="p-fluid mt-4 ">
        <h3>Giriş Yap</h3>
        <div className="field">
          <IconField className="p-float-label" iconPosition="left">
            <InputText
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              autoFocus
              className={classNames({ "p-invalid": isFormFieldValid("email") })}
            />
            <InputIcon className="pi pi-envelope" />
            <label
              htmlFor="email"
              className={classNames({ "p-error": isFormFieldValid("email") })}
            >
              Email
            </label>
          </IconField>
          {getFormErrorMessage("email")}
        </div>
        <div className="field">
          <IconField className="p-float-label" iconPosition="left">
            <Password
              id="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              className={classNames({
                "p-invalid": isFormFieldValid("password"),
              })}
              toggleMask
              // footer={PasswordFooter()}
              promptLabel="Şifrenizi girin"
              weakLabel="Çok basit"
              mediumLabel="Orta seviye"
              strongLabel="Güçlü"
              inputStyle={{ paddingLeft: "2rem" }}
            />
            <InputIcon className="pi pi-key" />
            <label
              htmlFor="password"
              className={classNames({
                "p-error": isFormFieldValid("password"),
              })}
            >
              Şifre
            </label>
          </IconField>
          {getFormErrorMessage("password")}
        </div>
        <Button type="submit" label="Gönder" className="mt-2" />
      </form>
    </>
  );
};

export default AdminLoginForm;
